const isSentryReportingEnabled = !!process.env.SENTRY_DSN;

const isSourceMapUploadingEnabled =
  process.env.ENABLE_SOURCE_MAP_UPLOADING === 'true' && process.env.SENTRY_AUTH_TOKEN;

module.exports = { isSentryReportingEnabled, isSourceMapUploadingEnabled };
